import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import Bs4MainDispatch from '../Bs4MainDispatch';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    color: '#44b700',
    boxShadow: `0 0 0 1px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      // animation: 'ripple 1.2s infinite ease-in-out',
      // border: '1px solid currentColor',
      content: '""',
    },
  },
}));

export const ViewAvatar = (props) => {
  const fileId = React.useMemo(() => {
    if (Array.isArray(props.fileId)) return props.fileId[0];
    return props.fileId;
  }, [props.fileId]);

  const [avatar, setAvatar] = React.useState(() => {
    const avatar = {
      fileId: fileId,
      initials: props.initials,
      label: props.label,
      imageBlobUrl: null,
      bgcolor: 'transparent',
      textColor: 'transparent',
    }

    return Bs4MainDispatch.getAvatar(avatar, null);
  });

  const avatarSize = React.useMemo(() => {
    const size = parseFloat(props.size);
    if (isNaN(size)) if (props.size) return props.size; else return null;
    return {width: size, height: size};
  }, [props.size]) 

  React.useEffect(() => {      
    Bs4MainDispatch.getAvatar(avatar, setAvatar);
  }, [fileId]); 

  const handleClick = (event) => {
    if (props.onClick) props.onClick(event);
  }

  return (
    <Avatar        
      onClick={handleClick}
      src={avatar.imageBlobUrl || (props.img || props.image_avatar) ? Bs4MainDispatch.getUrlPath(props.img || props.image_avatar) : null}
      alt={avatar.label}
      sizes={avatarSize+'px'}
      variant={props.img ? 'rounded' : 'circular'}
      sx={{
        bgcolor: avatar.bgcolor, 
        color: avatar.textColor,
        ...avatarSize,
        ...props.sx,
      }}
    >
      <Typography variant='subtitle1'>
        {avatar.initials}
      </Typography>
    </Avatar>      
  )
}

export default function Bs4ViewAvatar(props) {    
  
  if (props.circleColor) return (
    <StyledBadge 
      color="secondary" 
      overlap="circular" 
      variant="dot"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      sx={{'& .MuiBadge-badge': {backgroundColor: props.circleColor}}}
    >
      <ViewAvatar {...props}/>
    </StyledBadge>    
  );

  return <ViewAvatar {...props}/>
}